import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Card, Checkbox, Thumbnail, Text, IndexTable, Badge, SkeletonThumbnail } from '@shopify/polaris';

const LineItem = ({ index, pickOrder, lineItem, toggleChecked, checkedItems, unpickableItems, settings, hidePickedItems }) => {
  const toggle = () => {
    toggleChecked(lineItem.id);
  }

  if(lineItem.remainingQuantity > 0) {
    if(hidePickedItems && checkedItems.includes(lineItem.id)) {
      return (<></>);
    }

    return (
      <IndexTable.Row
        id={lineItem.id}
        key={lineItem.id}
        selected={checkedItems.includes(lineItem.id)}
        position={index}
        onClick={() => toggle()}
      >
        <IndexTable.Cell>
          { lineItem?.variant?.product?.featuredMedia?.preview?.image?.url && <Thumbnail size="small" source={lineItem?.variant?.product?.featuredMedia?.preview?.image?.url} alt={lineItem?.variant?.product?.featuredMedia?.preview?.image?.altText}/> }
          { !lineItem?.variant?.product?.featuredMedia?.preview?.image?.url && <SkeletonThumbnail size="small" /> }
        </IndexTable.Cell>
        <IndexTable.Cell>
          <Text>{lineItem.variant.displayName}</Text>
        </IndexTable.Cell>
        <IndexTable.Cell>
          <Text>{lineItem.variant.barcode}</Text>
        </IndexTable.Cell>
        <IndexTable.Cell>
          <Text>{lineItem.variant.sku}</Text>
        </IndexTable.Cell>
        <IndexTable.Cell>
          {lineItem.variant.selectedOptions.map(option => 
            <div key={option.name}>
              <Badge 
                tone="info"
                key={option.name}
              >
                <Text>{option.value}</Text>
              </Badge>
               &nbsp;
            </div>
          )}
        </IndexTable.Cell>
        <IndexTable.Cell>
          <Text as="span" alignment="end" numeric>
            {lineItem.remainingQuantity}
          </Text>
        </IndexTable.Cell>
      </IndexTable.Row>
    )
  }

  return (
    <>
    </>
  )
}

const mapStateToProps = state => ({
  pickOrder: state.pickOrder,
  checkedItems: state.pickOrder.checkedItems,
  unpickableItems: state.pickOrder.unpickableItems,
  // settings: state.settings.settings,
});

const mapDispatchToProps = (dispatch) => ({
  // searchOrder: (payload, orderId) => dispatch(readOrder(payload, orderId)),
  // pushCheckedList: (skuList) => dispatch(setCheckedList(skuList))
});

export default connect(mapStateToProps, mapDispatchToProps)(LineItem);